import type { Band } from "./types.ts";

export const BAND_ICONS: Record<Band, string> = {
  green: "✓",
  yellow: "~",
  red: "✕",
};

export const BAND_LABELS: Record<Band, string> = {
  green: "Cerca",
  yellow: "A media distancia",
  red: "Lejos",
};

export const BAND_EMOJI: Record<Band, string> = {
  green: "🟢",
  yellow: "🟡",
  red: "🔴",
};

export function bandForScore(score: number): Band {
  if (score >= 80) return "green";
  if (score >= 40) return "yellow";
  return "red";
}
